import { Button, Form, Input, Space, Typography } from "antd"
import { Main } from "../components/layout/Main"
import { BreadcrumbType } from "../types/types"
import { UserOutlined, MailOutlined, PhoneOutlined, FileDoneOutlined, FlagOutlined } from '@ant-design/icons'
import { useEffect } from "react"
import api from "../services/api"
import { InputDate } from "../components/objects/InputDate"
import dayjs, { Dayjs } from "dayjs"
import { toast } from "react-toastify"

const items: BreadcrumbType[] = [
    {
        title: 'Home'
    },
    {
        title: 'Usuário'
    },
    {
        title: 'Perfil',
    },
]

type FormValues = {
    nome: string
    estados: string
    email: string
    telefone: string
    cpf: string
}

export function Profile() {
    const [form] = Form.useForm()
    const onFinish = async (values: FormValues) => {
        await api.post('me/set', new URLSearchParams({
            nome: values.nome,
            email: values.email,
            telefone: values.telefone,
        }))
            .then((response) => {
                if (response.data.msg) {
                    toast.success(response.data.msg, { autoClose: 2000 })
                    loadData()
                } else {
                    toast.error(response.data)
                }
            })
            .catch((e) => {
                if (e.response) {
                    // Is this the correct way?
                    toast.error(e.response?.data.error)
                }

            })
    }

    async function loadData() {
        try {
            const response = await api.get('me/profile')
            form.setFieldsValue({
                nome: response.data.nome,
                estados: response.data.estados,
                email: response.data.email,
                telefone: response.data.telefone,
                cpf: response.data.cpf,
            })
        } catch (error) {
            console.error('Erro ao carregar dados do usuário:', error)
        }
    }

    useEffect(() => {
        loadData()
    }, [form])
    return (
        <Main itemBreadcrumb={items}>
            <Space direction="vertical" >
                <Typography.Title level={4}>
                    Meus Dados
                </Typography.Title>
                <Form
                    form={form}
                    name="profile"
                    className="login-form"
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="nome"

                        rules={[
                            {
                                required: true,
                                message: 'Digite seu Nome usado no Concurso',
                            },
                        ]}
                    >
                        <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Nome usado no concurso"  />
                    </Form.Item>
                    <Form.Item
                        name="estados"
                        rules={[
                            {
                                required: true,
                                message: 'Digite seu Estado do Concurso!',
                            },
                        ]}
                    >
                        <Input prefix={<FlagOutlined className="site-form-item-icon" />} placeholder="Estado do Concurso" disabled={true}/>
                    </Form.Item>
                    <Form.Item
                        name="email"
                        rules={[
                            {
                                required: true,
                                message: 'Digite seu e-mail!',
                            },
                        ]}
                    >
                        <Input prefix={<MailOutlined className="site-form-item-icon" />} placeholder="E-mail" />
                    </Form.Item>
                    <Form.Item
                        name="telefone"
                        rules={[
                            {
                                required: true,
                                message: 'Digite seu Telefone com Whatsapp!',
                            },
                        ]}
                    >
                        <Input prefix={<PhoneOutlined className="site-form-item-icon" />} placeholder="Telefone com Whatsapp"  />
                    </Form.Item>
                    <Form.Item
                        name="cpf"
                        rules={[
                            {
                                required: true,
                                message: 'Digite seu CPF!',
                            },
                        ]}
                    >
                        <Input prefix={<FileDoneOutlined className="site-form-item-icon" />} placeholder="CPF" disabled={true} />
                    </Form.Item>
                    <Form.Item className="login-submit">
                        <Button type="primary" htmlType="submit" className="login-form-button" >
                            Salvar
                        </Button>
                    </Form.Item>
                </Form>
            </Space>
        </Main>
    )
}
//onMouseOut={() => console.log(form.getFieldValue('birthdate'))}